import { useContext, useEffect } from 'react';
import { StyleSheetManager } from 'styled-components';
import { Outlet } from 'react-router-dom';

import { MixpanelContext } from '../wrappers/mixpanel';
import './i18n';
import { ToastContainer } from '../features/toasts/components/toasts-container';
import { setSentryUser } from '../lib/sentry';
import { useUserGuiding } from './hooks/use-userguiding';
import { useAuth } from '../workos-auth';

export const AppLayout = () => {
  const { user } = useAuth();
  const { init: initMixpanel, identify } = useContext(MixpanelContext);
  useUserGuiding();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      initMixpanel();
      identify(user);
      setSentryUser(user);
    }
  }, [initMixpanel, identify, user]);

  return (
    <StyleSheetManager enableVendorPrefixes>
      <Outlet />
      <ToastContainer />
    </StyleSheetManager>
  );
};
